import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import {Grammar} from "./views/system/Grammar";
import {DateSets, instance, resAware} from "./MobxStore";
import Dict from "./views/resAwareness/json/Dict_Mizhan.json"
import DF from "./views/system/DateFormat";
import {QDefSets, QDefValue, QType, Rtype, TimeScale, Utype, Vtype} from "./views/system/global";
import FileSaver from 'file-saver'
import md5 from 'js-md5'
import Axios from "./views/netapi/axiosService";
import allIot from './data/all_Iot.json'
import {QueryProp} from "./views/system/QueryProp";

//1619334000000 2021-04-25 15:00:00
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

Grammar.init((isConnected) => instance.mqttConnect(isConnected))
Grammar.webClientId(true)
// Grammar.update()

let a = "{}"
let aj = JSON.parse(a)
console.log(aj);

function getNumberInNormalDistribution(mean,std_dev){
  return mean+(randomNormalDistribution()*std_dev);
}


function randomNormalDistribution(){
  let u=0.0, v=0.0, w=0.0, c=0.0;
  do{
    //获得两个（-1,1）的独立随机变量
    u=Math.random()*2-1.0;
    v=Math.random()*2-1.0;
    w=u*u+v*v;
  }while(w==0.0||w>=1.0)
  //这里就是 Box-Muller转换
  c=Math.sqrt((-2*Math.log(w))/w);
  //返回2个标准正态分布的随机数，封装进一个数组返回
  //当然，因为这个函数运行较快，也可以扔掉一个
  //return [u*c,v*c];
  return u*c;
}

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Email App
const TheEmailApp = React.lazy(() => import('./views/apps/email/TheEmailApp'));

// Pages
// const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Drawings = React.lazy(() => import('./views/topology/core/Drawings'));
const Preview = React.lazy(() => import('./views/topology/Preview'));
const HnUPCD = React.lazy(() => import('./views/topology/examples/HnUPCD'));

const Login = React.lazy(() => import('./views/system/login/Login'));

class App extends Component {

  render() {
    return (
      <HashRouter>
          <React.Suspense fallback={loading}>
            <Switch>
              {/*<Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />*/}
              <Route exact path="/login" name="Login" render={props => <Login {...props}/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route exact path="/Drawings" name="Topology" render={props => <Drawings {...props}/>} />
              <Route exact path="/examples/HnUPCD" name="HnUPCD" render={props => <HnUPCD {...props}/>} />
              <Route exact path="/Preview" name="Preview" render={props => <Preview {...props}/>} />
              <Route path="/apps/email" name="Email App" render={props => <TheEmailApp {...props}/>} />
              <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
